import React, { useEffect, useState } from "react";
import styled from "styled-components";

import Button from "../components/button";
import Checkbox from "../components/checkbox";
import { InfoText, Link, RowContainer, ConsentLanguage } from "../components/description";
import Dropdown from "../components/dropdown";
import Error from "../components/error";
import Footer from "../components/footer";
import Icon from "../components/icon";
import ImageCheck from "../components/image-checkbox";
import Input from "../components/input";
import Label from "../components/label";

const PropertyWrapper = styled.div`
	.trust-signal {
		display: flex;
		flex-direction: row;
		justify-content: space-evenly;
		align-items: center;
		margin-top: 7rem;

		@media (max-width: 475px) {
			flex-direction: column;
		}
	}

	.browse-privately {
		display: flex;
		max-width: 200px;
		margin-right: 10px;

		@media (max-width: 475px) {
			margin-bottom: 4rem;
			margin-right: 0;
		}
	}
`;

function Property({ type, setFieldValue, ...props }) {
	const [isSectionVisited, setIsSectionVisited] = useState(false);
	const [yearsList, setYearsList] = useState([]);
	const [nofYearsList, setNofYearsList] = useState([]);
	const liabilityOptions = [
		{ label: "None", value: "None" },
		{ label: "$25,000", value: "25000" },
		{ label: "$50,000", value: "50000" },
		{ label: "$100,000", value: "100000" },
		{ label: "$200,000", value: "200000" },
		{ label: "$250,000", value: "250000" },
		{ label: "$300,000", value: "300000" },
		{ label: "$350,000", value: "350000" },
		{ label: "$400,000", value: "400000" },
		{ label: "$450,000", value: "450000" },
		{ label: "$500,000", value: "500000" },
		{ label: "$750,000", value: "750000" },
		{ label: "$1,000,000", value: "1000000" },
		{ label: "$2,000,000", value: "2000000" },
		{ label: "$3,000,000", value: "3000000" },
		{ label: "$4,000,000", value: "4000000" },
		{ label: "$5,000,000", value: "5000000" },
	];

	const [showPropertyType, setShowPropertyType] = useState(true);
	const [showNofYearsLived, setShowNofYearsLived] = useState(false);
	const [showSquareFootage, setShowSquareFootage] = useState(false);
	const [showYearBuilt, setShowYearBuilt] = useState(false);
	const [showRoofUpgradeYear, setShowRoofUpgradeYear] = useState(false);
	const [showDwellingAmount, setShowDwellingAmount] = useState(false);
	const [showNofFloors, setShowNofFloors] = useState(false);
	const [showConstructionType, setShowConstructionType] = useState(false);
	const [showFoundationType, setShowFoundationType] = useState(false);
	const [showRoofMaterial, setShowRoofMaterial] = useState(false);
	const [showOptionalFacilities, setShowOptionalFacilities] = useState(false);
	const [showPropertyInsurance, setShowPropertyInsurance] = useState(false);
	const [showDiscounts, setShowDiscounts] = useState(false);

	useEffect(() => {
		const sectionFinished = sessionStorage.getItem("rrQuizPropertySectionVisited");
		if (sectionFinished && sectionFinished == "true") {
			setIsSectionVisited(true);
		} else {
			if (type != "HOME" && !props.values.property.policyType) {
				setShowPropertyType(true);
			} else if (type == "HOME" && (!props.values.property.policyType || !props.values.property.zip)) {
				setShowPropertyType(true);
			} else if (!props.values.property.yearsOwned) {
				setShowPropertyType(false);
				setShowNofYearsLived(true);
			} else if (!props.values.property.squareFootage) {
				setShowPropertyType(false);
				setShowNofYearsLived(false);
				setShowSquareFootage(true);
			} else if ((props.values.property.policyType == "HO-3" || props.values.property.policyType == "HO-6") && !props.values.property.constructionYear) {
				setShowPropertyType(false);
				setShowNofYearsLived(false);
				setShowSquareFootage(false);
				setShowYearBuilt(true);
			} else if ((props.values.property.policyType == "HO-3" || props.values.property.policyType == "HO-6") && !props.values.property.roofLastUpgradedYear) {
				setShowPropertyType(false);
				setShowNofYearsLived(false);
				setShowSquareFootage(false);
				setShowYearBuilt(false);
				setShowRoofUpgradeYear(true);
			} else if (
				((props.values.property.policyType == "HO-3" || props.values.property.policyType == "HO-6") &&
					(!props.values.property.dwellingAmount || !props.values.property.personalPropertyAmount || !props.values.property.personalLiabilityAmount)) ||
				(props.values.property.policyType == "HO-4" && (!props.values.property.personalPropertyAmount || !props.values.property.personalLiabilityAmount))
			) {
				setShowPropertyType(false);
				setShowNofYearsLived(false);
				setShowSquareFootage(false);
				setShowYearBuilt(false);
				setShowRoofUpgradeYear(false);
				setShowDwellingAmount(true);
			} else if (!props.values.property.nofStories) {
				setShowPropertyType(false);
				setShowNofYearsLived(false);
				setShowSquareFootage(false);
				setShowYearBuilt(false);
				setShowRoofUpgradeYear(false);
				setShowDwellingAmount(false);
				setShowNofFloors(true);
			} else if ((props.values.property.policyType == "HO-3" || props.values.property.policyType == "HO-6") && !props.values.property.constructionType) {
				setShowPropertyType(false);
				setShowNofYearsLived(false);
				setShowSquareFootage(false);
				setShowYearBuilt(false);
				setShowRoofUpgradeYear(false);
				setShowDwellingAmount(false);
				setShowNofFloors(false);
				setShowConstructionType(true);
			} else if ((props.values.property.policyType == "HO-3" || props.values.property.policyType == "HO-6") && !props.values.property.substructureType) {
				setShowPropertyType(false);
				setShowNofYearsLived(false);
				setShowSquareFootage(false);
				setShowYearBuilt(false);
				setShowRoofUpgradeYear(false);
				setShowDwellingAmount(false);
				setShowNofFloors(false);
				setShowConstructionType(false);
				setShowFoundationType(true);
			} else if ((props.values.property.policyType == "HO-3" || props.values.property.policyType == "HO-6") && !props.values.property.roofType) {
				setShowPropertyType(false);
				setShowNofYearsLived(false);
				setShowSquareFootage(false);
				setShowYearBuilt(false);
				setShowRoofUpgradeYear(false);
				setShowDwellingAmount(false);
				setShowNofFloors(false);
				setShowConstructionType(false);
				setShowFoundationType(false);
				setShowRoofMaterial(true);
			} else if (!props.values.property.isCurrentlyInsured) {
				setShowPropertyType(false);
				setShowNofYearsLived(false);
				setShowSquareFootage(false);
				setShowYearBuilt(false);
				setShowRoofUpgradeYear(false);
				setShowDwellingAmount(false);
				setShowNofFloors(false);
				setShowConstructionType(false);
				setShowFoundationType(false);
				setShowRoofMaterial(false);
				setShowOptionalFacilities(true);
			} else if (
				props.values.property.isCurrentlyInsured &&
				props.values.property.isCurrentlyInsured === "true" &&
				(!props.values.property.insuredForYears || !props.values.property.claimFreeYears)
			) {
				setShowPropertyType(false);
				setShowNofYearsLived(false);
				setShowSquareFootage(false);
				setShowYearBuilt(false);
				setShowRoofUpgradeYear(false);
				setShowDwellingAmount(false);
				setShowNofFloors(false);
				setShowConstructionType(false);
				setShowFoundationType(false);
				setShowRoofMaterial(false);
				setShowOptionalFacilities(false);
				setShowPropertyInsurance(true);
			} else {
				setShowPropertyType(false);
				setShowNofYearsLived(false);
				setShowSquareFootage(false);
				setShowYearBuilt(false);
				setShowRoofUpgradeYear(false);
				setShowDwellingAmount(false);
				setShowNofFloors(false);
				setShowConstructionType(false);
				setShowFoundationType(false);
				setShowRoofMaterial(false);
				setShowOptionalFacilities(false);
				setShowPropertyInsurance(false);
				setShowDiscounts(true);
			}
		}
		window.scroll({ top: 0, left: 0, behavior: "smooth" });
	}, []);

	useEffect(() => {
		let tempYears = [];
		for (let i = new Date().getFullYear(); i >= 1950; i--) {
			tempYears.push({ label: i, value: i });
		}
		setYearsList(tempYears);

		tempYears = [];
		for (let i = 1; i <= 50; i++) {
			tempYears.push({ label: i, value: i });
		}
		setNofYearsList(tempYears);
	}, []);

	const handleNumericChangeZip = (e) => {
		const { value } = e.target;
		if ((value === "" || /^[0-9]*$/.test(value)) && value.length <= 5) {
			setFieldValue("property.zip", value);
			setFieldValue("zip", value);
		}
	};
	function onPropertyTypeNext() {
		props.setTouched({
			property: {
				zip: true,
				policyType: true,
			},
		});
		props.validateForm().then((errors) => {
			if ((props.values.property.policyType != "" && errors["property"] && Object.keys(errors["property"]).indexOf("zip") == -1) || !errors["property"]) {
				setShowPropertyType(false);
				setShowNofYearsLived(true);
				document.getElementById("rr-quiz-flow-heading-mobile") ? (document.getElementById("rr-quiz-flow-heading-mobile").style.display = "none") : undefined;
				document.getElementById("rr-quiz-flow-subheading-mobile") ? (document.getElementById("rr-quiz-flow-subheading-mobile").style.display = "none") : undefined;
				document.getElementById("rr-quiz-flow-heading-desktop") ? (document.getElementById("rr-quiz-flow-heading-desktop").style.display = "none") : undefined;
				document.getElementById("rr-quiz-flow-subheading-desktop") ? (document.getElementById("rr-quiz-flow-subheading-desktop").style.display = "none") : undefined;
			} else {
				console.log(errors);
			}
		});
	}
	function onPropertyTypeChange(value) {
		setFieldValue("property.policyType", value);
		if (type != "HOME") {
			setTimeout(() => {
				setShowPropertyType(false);
				setShowNofYearsLived(true);
				document.getElementById("rr-quiz-flow-heading-mobile") ? (document.getElementById("rr-quiz-flow-heading-mobile").style.display = "none") : undefined;
				document.getElementById("rr-quiz-flow-subheading-mobile") ? (document.getElementById("rr-quiz-flow-subheading-mobile").style.display = "none") : undefined;
				document.getElementById("rr-quiz-flow-heading-desktop") ? (document.getElementById("rr-quiz-flow-heading-desktop").style.display = "none") : undefined;
				document.getElementById("rr-quiz-flow-subheading-desktop") ? (document.getElementById("rr-quiz-flow-subheading-desktop").style.display = "none") : undefined;
			}, 200);
		}
	}

	function onNumberOfYearsLivedChange(value) {
		setFieldValue("property.yearsOwned", value);
		setTimeout(() => {
			props.validateForm().then((errors) => {
				if ((errors["property"] && Object.keys(errors["property"]).indexOf("yearsOwned") == -1) || !errors["property"]) {
					setShowNofYearsLived(false);
					setShowSquareFootage(true);
				}
			});
		}, 300);
	}

	function onPropertyYearsOwnedBack() {
		setShowNofYearsLived(false);
		setShowPropertyType(true);
	}
	function onPropertyYearsOwnedNext() {
		props.setTouched({
			property: {
				yearsOwned: true,
			},
		});
		props.validateForm().then((errors) => {
			if (props.values.property.yearsOwned != "") {
				setShowNofYearsLived(false);
				setShowSquareFootage(true);
			} else {
				console.log(errors);
			}
		});
	}

	const handleNumericChangeSquareF = (e) => {
		const { value } = e.target;
		if ((value === "" || /^[0-9]*$/.test(value)) && value.length <= 5) {
			if (value) {
				setFieldValue("property.squareFootage", parseInt(value));
			} else {
				setFieldValue("property.squareFootage", value);
			}
		}
	};
	function onPropertySquareFootageBack() {
		setShowSquareFootage(false);
		setShowNofYearsLived(true);
	}
	function onPropertySquareFootageNext() {
		props.setTouched({
			property: {
				squareFootage: true,
			},
		});
		props.validateForm().then((errors) => {
			if (!errors["property"] || (errors["property"] && Object.keys(errors["property"]).indexOf("squareFootage") == -1)) {
				setShowSquareFootage(false);
				if (props.values.property.policyType === "HO-3" || props.values.property.policyType === "HO-6") {
					setShowYearBuilt(true);
				} else {
					setShowDwellingAmount(true);
				}
			} else {
				console.log(errors);
			}
		});
	}

	function onPropertyYearBuiltBack() {
		setShowYearBuilt(false);
		setShowSquareFootage(true);
	}
	function onPropertyYearBuiltNext() {
		props.setTouched({
			property: {
				constructionYear: true,
			},
		});
		props.validateForm().then((errors) => {
			if (props.values.property.constructionYear != "") {
				setShowYearBuilt(false);
				setShowRoofUpgradeYear(true);
			} else {
				console.log(errors);
			}
		});
	}

	function onPropertyRoofYearBack() {
		setShowRoofUpgradeYear(false);
		setShowYearBuilt(true);
	}
	function onPropertyRoofYearNext() {
		props.setTouched({
			property: {
				roofLastUpgradedYear: true,
			},
		});
		props.validateForm().then((errors) => {
			if (props.values.property.roofLastUpgradedYear != "") {
				setShowRoofUpgradeYear(false);
				setShowDwellingAmount(true);
			} else {
				console.log(errors);
			}
		});
	}

	const handleNumericChangeDwelling = (e) => {
		const { value } = e.target;
		if ((value === "" || /^[0-9]*$/.test(value)) && value.length <= 8) {
			if (value) {
				setFieldValue("property.dwellingAmount", parseInt(value));
				setFieldValue("property.personalPropertyAmount", parseInt(parseInt(value) / 2));
			} else {
				setFieldValue("property.dwellingAmount", value);
				setFieldValue("property.personalPropertyAmount", "");
			}
		}
	};
	function onPropertyAmountsBack() {
		setShowDwellingAmount(false);
		if (props.values.property.policyType === "HO-3" || props.values.property.policyType === "HO-6") {
			setShowRoofUpgradeYear(true);
		} else {
			setShowSquareFootage(true);
		}
	}
	function onPropertyAmountsNext() {
		props.setTouched({
			property: {
				dwellingAmount: props.values.property.policyType === "HO-3" || props.values.property.policyType === "HO-6" ? true : false,
				personalPropertyAmount: true,
				personalLiabilityAmount: true,
			},
		});
		props.validateForm().then((errors) => console.log(errors));
		if (props.values.property.policyType === "HO-3" || props.values.property.policyType === "HO-6") {
			if (props.values.property.dwellingAmount != "" && props.values.property.personalPropertyAmount != "" && props.values.property.personalLiabilityAmount != "") {
				setShowDwellingAmount(false);
				setShowNofFloors(true);
			}
		} else {
			if (props.values.property.personalPropertyAmount != "" && props.values.property.personalLiabilityAmount != "") {
				setShowDwellingAmount(false);
				setShowNofFloors(true);
			}
		}
	}

	function onNofStoriesChange(value) {
		setFieldValue("property.nofStories", value);
		setTimeout(() => {
			setShowNofFloors(false);
			if (props.values.property.policyType === "HO-3" || props.values.property.policyType === "HO-6") {
				setShowConstructionType(true);
			} else {
				setShowOptionalFacilities(true);
			}
		}, 200);
	}
	function onPropertyFloorsBack() {
		setShowNofFloors(false);
		setShowDwellingAmount(true);
	}
	function onPropertyFloorsNext() {
		props.setTouched({
			property: {
				nofStories: true,
			},
		});
		props.validateForm().then((errors) => {
			if (props.values.property.nofStories != "") {
				setShowNofFloors(false);
				if (props.values.property.policyType === "HO-3" || props.values.property.policyType === "HO-6") {
					setShowConstructionType(true);
				} else {
					setShowOptionalFacilities(true);
				}
			} else {
				console.log(errors);
			}
		});
	}

	function onConstructionTypeChange(value) {
		setFieldValue("property.constructionType", value);
		setTimeout(() => {
			setShowConstructionType(false);
			setShowFoundationType(true);
		}, 200);
	}
	function onPropertyConstructionTypeBack() {
		setShowConstructionType(false);
		setShowNofFloors(true);
	}
	function onPropertyConstructionTypeNext() {
		props.setTouched({
			property: {
				constructionType: true,
			},
		});
		props.validateForm().then((errors) => {
			if (props.values.property.constructionType != "") {
				setShowConstructionType(false);
				setShowFoundationType(true);
			} else {
				console.log(errors);
			}
		});
	}

	function onFoundationTypeChange(value) {
		setFieldValue("property.substructureType", value);
		setTimeout(() => {
			setShowFoundationType(false);
			setShowRoofMaterial(true);
		}, 200);
	}
	function onPropertyFoundationTypeBack() {
		setShowFoundationType(false);
		setShowConstructionType(true);
	}
	function onPropertyFoundationTypeNext() {
		props.setTouched({
			property: {
				substructureType: true,
			},
		});
		props.validateForm().then((errors) => {
			if (props.values.property.substructureType != "") {
				setShowFoundationType(false);
				setShowRoofMaterial(true);
			} else {
				console.log(errors);
			}
		});
	}

	function onRoofMaterialChange(value) {
		setFieldValue("property.roofType", value);
		setTimeout(() => {
			setShowRoofMaterial(false);
			setShowOptionalFacilities(true);
		}, 200);
	}
	function onPropertyRoofMaterialBack() {
		setShowRoofMaterial(false);
		setShowFoundationType(true);
	}
	function onPropertyRoofMaterialNext() {
		props.setTouched({
			property: {
				roofType: true,
			},
		});
		props.validateForm().then((errors) => {
			if (props.values.property.roofType != "") {
				setShowRoofMaterial(false);
				setShowOptionalFacilities(true);
			} else {
				console.log(errors);
			}
		});
	}

	function onPropertyOptionalFacilityBack() {
		setShowOptionalFacilities(false);
		if (props.values.property.policyType === "HO-3" || props.values.property.policyType === "HO-6") {
			setShowRoofMaterial(true);
		} else {
			setShowNofFloors(true);
		}
	}
	function onPropertyOptionalFacilityNext() {
		setShowOptionalFacilities(false);
		setShowPropertyInsurance(true);
	}

	function onPropertyInsuranceBack() {
		setShowPropertyInsurance(false);
		setShowOptionalFacilities(true);
	}
	function onPropertyInsuranceNext() {
		props.setTouched({
			property: {
				isCurrentlyInsured: true,
				insuredForYears: true,
				claimFreeYears: true,
			},
		});
		props.validateForm().then((errors) => {
			if (
				props.values.property.isCurrentlyInsured == "false" ||
				(props.values.property.isCurrentlyInsured == "true" && props.values.property.claimFreeYears >= 0 && props.values.property.insuredForYears != "")
			) {
				setShowPropertyInsurance(false);
				setShowDiscounts(true);
			} else {
				console.log(errors);
			}
		});
	}

	function onPropertyDiscountChange(key) {
		let tempVal = "false";
		if (props.values.property[key] === "false") {
			tempVal = "true";
		}
		setFieldValue(`property.${key}`, tempVal);
	}
	function onDiscountsBack() {
		setShowDiscounts(false);
		setShowPropertyInsurance(true);
	}

	function getRates() {
		setFieldValue("queryType", type);
		props.setTouched({
			property: {
				policyType: true,
				yearsOwned: true,
				squareFootage: true,
				constructionYear: true,
				roofLastUpgradedYear: true,
				dwellingAmount: true,
				personalPropertyAmount: true,
				personalLiabilityAmount: true,
				nofStories: true,
				constructionType: true,
				substructureType: true,
				roofType: true,
				isCurrentlyInsured: true,
				insuredForYears: true,
				claimFreeYears: true,
			},
		});
		props.validateForm().then((errors) => {
			props.setErrorSubmitting(false);
			if (Object.keys(errors).length === 0) {
				const newItems = [...props.steps];
				let currentStepIndex = newItems.findIndex((row) => row.key === "PROPERTY");
				let step = newItems[currentStepIndex];
				step.isVisited = "true";
				step.isDisabled = "false";
				newItems[currentStepIndex] = step;
				props.setSteps(newItems);

				props.setProgressPercentage(100);
				document.getElementById("finley-spinner-search") && document.getElementById("finley-spinner-search").classList.add("show");
				props.setIsSubmitInProgress(true);
				props.setIsPropertySectionCompleted(true);
				sessionStorage.setItem("rrQuizPropertySectionVisited", "true");
				props.submitForm();
			} else {
				console.log(errors);
			}
		});
	}
	function propertyContinueClick() {
		props.setTouched({
			property: {
				zip: true,
				policyType: true,
				yearsOwned: true,
				squareFootage: true,
				constructionYear: true,
				roofLastUpgradedYear: true,
				dwellingAmount: true,
				personalPropertyAmount: true,
				personalLiabilityAmount: true,
				nofStories: true,
				constructionType: true,
				substructureType: true,
				roofType: true,
				isCurrentlyInsured: true,
				insuredForYears: true,
				claimFreeYears: true,
			},
		});
		props.validateForm().then((errors) => {
			if (Object.keys(errors).length === 0) {
				props.setIsPropertySectionCompleted(true);
				const newItems = [...props.steps];
				// Current step
				let currentStepIndex = newItems.findIndex((row) => row.key === "PROPERTY");
				let step = newItems[currentStepIndex];
				step.isVisited = "true";
				step.isDisabled = "false";
				newItems[currentStepIndex] = step;
				// Next step
				step = newItems[currentStepIndex + 1];
				step.isDisabled = "false";
				newItems[currentStepIndex + 1] = step;
				props.setSteps(newItems);

				if (props.values.bundleInsurance == "true") {
					props.setProgressPercentage(20);
				} else {
					props.setProgressPercentage(50);
				}
				sessionStorage.setItem("rrQuizPropertySectionVisited", "true");
				props.goToNextStep("PERSONAL", true);
			} else {
				console.log(errors);
			}
		});
	}

	return (
		<PropertyWrapper>
			{props.values.property && (
				<React.Fragment>
					{(isSectionVisited || showPropertyType) && (
						<React.Fragment>
							{type == "HOME" && (
								<Input
									name="property.zip"
									placeholder="Zip code"
									label="What is your zip code?"
									onChange={(e) => {
										handleNumericChangeZip(e);
									}}
									onBlur={(e) => {
										props.handleBlur(e);
										props.setStateValue();
									}}
									error={`${props.touched && props.touched.property && props.touched.property.zip && props.errors && props.errors.property && props.errors.property.zip}`}
								/>
							)}

							<Label text="What type of property do you have?"></Label>
							<div style={{ display: "flex", flexDirection: "row" }}>
								<Checkbox
									label="Home"
									checked={props.values.property.policyType === "HO-3"}
									onClick={() => {
										onPropertyTypeChange("HO-3");
									}}
									style={{ marginRight: "1rem", width: "100%" }}
								/>
								<Checkbox
									label="Rental"
									checked={props.values.property.policyType === "HO-4"}
									onClick={() => {
										if (!props.values.property.personalPropertyAmount) {
											setFieldValue("property.personalPropertyAmount", 30000);
										}
										onPropertyTypeChange("HO-4");
									}}
									style={{ width: "100%" }}
								/>
							</div>
							<div style={{ display: "flex", flexDirection: "row" }}>
								<Checkbox
									label="Condo"
									checked={props.values.property.policyType === "HO-6"}
									onClick={() => {
										onPropertyTypeChange("HO-6");
									}}
									style={{ marginRight: "2.5rem", width: "100%" }}
								/>
								<div style={{ width: "100%" }}></div>
							</div>
							{props.touched && props.touched.property && props.touched.property.policyType && props.errors && props.errors.property && props.errors.property.policyType && (
								<Error text={props.errors.property.policyType} />
							)}

							{!isSectionVisited && <Footer showBack={false} forwardClick={() => onPropertyTypeNext()} />}

							{!isSectionVisited && type == "HOME" && (
								<div className="trust-signal">
									<div className="browse-privately">
										<Icon viewBox="0 0 30 38" icon="lock" size={24} stroke="#004ECC" color="#004ECC" />
										<div style={{ display: "flex", flexDirection: "column" }}>
											<span style={{ fontSize: "16px", fontWeight: "800" }}>Browse Privately</span>
											<span style={{ fontSize: "15px", lineHeight: "20px" }}>We won't ask for your phone or email now</span>
										</div>
									</div>
									<img style={{ height: "50px" }} src="/wp-content/uploads/2026/06/blue-seal-200-42-bbb-235981197.png" />
								</div>
							)}
						</React.Fragment>
					)}

					{(isSectionVisited || showNofYearsLived) && (
						<React.Fragment>
							<Label text="How many years have you lived there?"></Label>
							<Dropdown
								placeholder="Select number of years"
								name="property.yearsOwned"
								value="property.yearsOwned"
								onChange={(value) => {
									onNumberOfYearsLivedChange(value);
								}}
								options={nofYearsList}
								error={`${props.touched && props.touched.property && props.touched.property.yearsOwned && props.errors && props.errors.property && props.errors.property.yearsOwned}`}
								marginBottom="1rem"
							/>
							{!isSectionVisited && <Footer backClick={() => onPropertyYearsOwnedBack()} forwardClick={() => onPropertyYearsOwnedNext()} />}
						</React.Fragment>
					)}

					{(isSectionVisited || showSquareFootage) && (
						<>
							<Input
								name="property.squareFootage"
								placeholder="Square footage"
								label="What is the square footage?"
								onChange={(e) => {
									handleNumericChangeSquareF(e);
								}}
								onBlur={async (e) => {
									await props.handleBlur(e);
									await props.validateField("property.squareFootage");
									// if (e.target.value) {
									// 	setShowSquareFootage(false);
									// 	if (props.values.property.policyType === "HO-3" || props.values.property.policyType === "HO-6") {
									// 		setShowYearBuilt(true);
									// 	} else {
									// 		setShowDwellingAmount(true);
									// 	}
									// }
								}}
								error={props.touched && props.touched.property && props.touched.property.squareFootage && props.errors && props.errors.property && props.errors.property.squareFootage}
							/>
							{!isSectionVisited && <Footer backClick={() => onPropertySquareFootageBack()} forwardClick={() => onPropertySquareFootageNext()} />}
						</>
					)}

					{(isSectionVisited || showYearBuilt) && (props.values.property.policyType === "HO-3" || props.values.property.policyType === "HO-6") && (
						<React.Fragment>
							<Label text="What year was your home built?"></Label>
							<Dropdown
								placeholder="Select year"
								name="property.constructionYear"
								value="property.constructionYear"
								onChange={(value) => {
									setFieldValue("property.constructionYear", value);
									setTimeout(() => {
										props.validateForm().then((errors) => {
											if ((errors["property"] && Object.keys(errors["property"]).indexOf("constructionYear") == -1) || !errors["property"]) {
												setShowYearBuilt(false);
												setShowRoofUpgradeYear(true);
											}
										});
									}, 300);
								}}
								options={yearsList}
								error={`${
									props.touched &&
									props.touched.property &&
									props.touched.property.constructionYear &&
									props.errors &&
									props.errors.property &&
									props.errors.property.constructionYear
								}`}
								marginBottom="1rem"
							/>
							{!isSectionVisited && <Footer backClick={() => onPropertyYearBuiltBack()} forwardClick={() => onPropertyYearBuiltNext()} />}
						</React.Fragment>
					)}

					{(isSectionVisited || showRoofUpgradeYear) && (props.values.property.policyType === "HO-3" || props.values.property.policyType === "HO-6") && (
						<React.Fragment>
							<Label text="What year was your roof last replaced?"></Label>
							<Dropdown
								placeholder="Select year"
								name="property.roofLastUpgradedYear"
								value="property.roofLastUpgradedYear"
								onChange={(value) => {
									setFieldValue("property.roofLastUpgradedYear", value);
									setTimeout(() => {
										props.validateForm().then((errors) => {
											if ((errors["property"] && Object.keys(errors["property"]).indexOf("roofLastUpgradedYear") == -1) || !errors["property"]) {
												setShowRoofUpgradeYear(false);
												setShowDwellingAmount(true);
											}
										});
									}, 300);
								}}
								options={yearsList}
								error={`${
									props.touched &&
									props.touched.property &&
									props.touched.property.roofLastUpgradedYear &&
									props.errors &&
									props.errors.property &&
									props.errors.property.roofLastUpgradedYear
								}`}
								marginBottom="1rem"
							/>
							{!isSectionVisited && <Footer backClick={() => onPropertyRoofYearBack()} forwardClick={() => onPropertyRoofYearNext()} />}
						</React.Fragment>
					)}

					{(isSectionVisited || showDwellingAmount) && (
						<React.Fragment>
							{(props.values.property.policyType === "HO-3" || props.values.property.policyType === "HO-6") && (
								<>
									<Input
										name="property.dwellingAmount"
										placeholder="Estimated cost"
										adorment="$"
										adormentposition="left"
										label="Estimate what it would cost to rebuild your home?"
										onChange={(e) => {
											handleNumericChangeDwelling(e);
										}}
										onBlur={(e) => {}}
										error={
											props.touched &&
											props.touched.property &&
											props.touched.property.dwellingAmount &&
											props.errors &&
											props.errors.property &&
											props.errors.property.dwellingAmount
										}
									/>
									<InfoText text="To estimate your rebuild cost, multiply the square footage of your home by $150, or the average cost per square foot in your area. We use this value to set your dwelling coverage." />
								</>
							)}

							<Input
								name="property.personalPropertyAmount"
								placeholder="Personal property amount"
								adorment="$"
								adormentposition="left"
								label="Personal property amount"
								onChange={(e) => {
									const { value } = e.target;
									if ((value === "" || /^[0-9]*$/.test(value)) && value.length <= 8) {
										if (value) {
											setFieldValue("property.personalPropertyAmount", parseInt(value));
										} else {
											setFieldValue("property.personalPropertyAmount", value);
										}
									}
								}}
								onBlur={(e) => {}}
								error={
									props.touched &&
									props.touched.property &&
									props.touched.property.personalPropertyAmount &&
									props.errors &&
									props.errors.property &&
									props.errors.property.personalPropertyAmount
								}
							/>
							<InfoText text="Provides coverage for your personal belongings. We default this to half of your rebuild cost or $30k for renters. You may need more or less based on the value of your belongings." />

							<Label text="Personal liability coverage"></Label>
							<Dropdown
								placeholder="Select liability coverage"
								name="property.personalLiabilityAmount"
								value="property.personalLiabilityAmount"
								onChange={(value) => {
									setFieldValue("property.personalLiabilityAmount", value);
								}}
								options={liabilityOptions}
								error={`${
									props.touched &&
									props.touched.property &&
									props.touched.property.personalLiabilityAmount &&
									props.errors &&
									props.errors.property &&
									props.errors.property.personalLiabilityAmount
								}`}
								marginBottom="1rem"
							/>
							<InfoText text="Provides coverage if someone gets injured on your property, or if you accidentally damage someone else's property. We default this coverage to $300k." />

							{!isSectionVisited && <Footer backClick={() => onPropertyAmountsBack()} forwardClick={() => onPropertyAmountsNext()} />}
						</React.Fragment>
					)}

					{(isSectionVisited || showNofFloors) && (
						<React.Fragment>
							<Label text="How many floors does your home have?"></Label>
							<div style={{ display: "flex", flexDirection: "row" }}>
								<Checkbox
									label="1"
									checked={props.values.property.nofStories === "1"}
									onClick={() => {
										onNofStoriesChange("1");
									}}
									style={{ marginRight: "1rem", width: "100%" }}
								/>
								<Checkbox
									label="2"
									checked={props.values.property.nofStories === "2"}
									onClick={() => {
										onNofStoriesChange("2");
									}}
									style={{ width: "100%" }}
								/>
							</div>
							<div style={{ display: "flex", flexDirection: "row" }}>
								<Checkbox
									label="3"
									checked={props.values.property.nofStories === "3"}
									onClick={() => {
										onNofStoriesChange("3");
									}}
									style={{ marginRight: "1rem", width: "100%" }}
								/>
								<Checkbox
									label="4"
									checked={props.values.property.nofStories === "4"}
									onClick={() => {
										onNofStoriesChange("4");
									}}
									style={{ width: "100%" }}
								/>
							</div>
							{props.touched && props.touched.property && props.touched.property.nofStories && props.errors && props.errors.property && props.errors.property.nofStories && (
								<Error text={props.errors.property.nofStories} />
							)}
							{!isSectionVisited && <Footer backClick={() => onPropertyFloorsBack()} forwardClick={() => onPropertyFloorsNext()} />}
						</React.Fragment>
					)}

					{(isSectionVisited || showConstructionType) && (props.values.property.policyType === "HO-3" || props.values.property.policyType === "HO-6") && (
						<React.Fragment>
							<Label text="Home construction type:"></Label>
							<RowContainer>
								<ImageCheck
									label="Frame"
									src="/wp-content/uploads/2023/10/construction-type-01-frame.jpg"
									checked={props.values.property.constructionType === "Frame"}
									onClick={() => {
										onConstructionTypeChange("Frame");
									}}
									style={{ marginRight: "1rem", width: "100%" }}
								/>
								<ImageCheck
									label="Masonary"
									src="/wp-content/uploads/2023/10/construction-type-02-masonry.jpg"
									checked={props.values.property.constructionType === "Masonary"}
									onClick={() => {
										onConstructionTypeChange("Masonary");
									}}
									style={{ width: "100%" }}
								/>
							</RowContainer>
							<RowContainer>
								<ImageCheck
									label="Adobe"
									src="/wp-content/uploads/2023/10/construction-type-03-adobe.jpg"
									checked={props.values.property.constructionType === "Adobe"}
									onClick={() => {
										onConstructionTypeChange("Adobe");
									}}
									style={{ marginRight: "1rem", width: "100%" }}
								/>
								<ImageCheck
									label="Log"
									src="/wp-content/uploads/2023/10/construction-type-04-log.jpg"
									checked={props.values.property.constructionType === "Log"}
									onClick={() => {
										onConstructionTypeChange("Log");
									}}
									style={{ width: "100%" }}
								/>
							</RowContainer>
							<RowContainer>
								<ImageCheck
									label="Other"
									src="/wp-content/uploads/2023/10/construction-type-05-other.jpg"
									checked={props.values.property.constructionType === "Other"}
									onClick={() => {
										onConstructionTypeChange("Other");
									}}
									style={{ marginRight: "1rem", width: "100%" }}
								/>
								<ImageCheck
									label="I'm not sure"
									src="/wp-content/uploads/2024/08/question-mark-bubble-speech-sign-symbol-icon-3d-rendering-scaled.jpg"
									checked={props.values.property.constructionType === "Unsure"}
									onClick={() => {
										onConstructionTypeChange("Unsure");
									}}
									style={{ width: "100%" }}
								/>
							</RowContainer>
							{props.touched && props.touched.property && props.touched.property.constructionType && props.errors && props.errors.property && props.errors.property.constructionType && (
								<Error text={props.errors.property.constructionType} />
							)}
							{!isSectionVisited && <Footer backClick={() => onPropertyConstructionTypeBack()} forwardClick={() => onPropertyConstructionTypeNext()} />}
						</React.Fragment>
					)}

					{(isSectionVisited || showFoundationType) && (props.values.property.policyType === "HO-3" || props.values.property.policyType === "HO-6") && (
						<React.Fragment>
							<Label text="What type of foundation does your home have?"></Label>
							<RowContainer>
								<ImageCheck
									label="Basement"
									src="/wp-content/uploads/2023/10/type-of-foundation-01-basement.jpg"
									checked={props.values.property.substructureType === "Basement"}
									onClick={() => {
										onFoundationTypeChange("Basement");
									}}
									style={{ marginRight: "1rem", width: "100%" }}
								/>
								<ImageCheck
									label="Slab"
									src="/wp-content/uploads/2023/10/type-of-foundation-02-slab.jpg"
									checked={props.values.property.substructureType === "Slab"}
									onClick={() => {
										onFoundationTypeChange("Slab");
									}}
									style={{ width: "100%" }}
								/>
							</RowContainer>
							<RowContainer>
								<ImageCheck
									label="Crawl space"
									src="/wp-content/uploads/2023/10/type-of-foundation-03-crawl-space.jpg"
									checked={props.values.property.substructureType === "Crawl-Space"}
									onClick={() => {
										onFoundationTypeChange("Crawl-Space");
									}}
									style={{ marginRight: "1rem", width: "100%" }}
								/>
								<ImageCheck
									label="Piers/Stilts"
									src="/wp-content/uploads/2023/10/type-of-foundation-04-piers-stilts.jpg"
									checked={props.values.property.substructureType === "Piers/Pilings/Stilts"}
									onClick={() => {
										onFoundationTypeChange("Piers/Pilings/Stilts");
									}}
									style={{ width: "100%" }}
								/>
							</RowContainer>
							<RowContainer>
								<ImageCheck
									label="I'm not sure"
									src="/wp-content/uploads/2024/08/question-mark-bubble-speech-sign-symbol-icon-3d-rendering-scaled.jpg"
									checked={props.values.property.substructureType === "Other"}
									onClick={() => {
										onFoundationTypeChange("Other");
									}}
									style={{ marginRight: "2.5rem", width: "100%" }}
								/>
								<div style={{ width: "100%" }}></div>
							</RowContainer>
							{props.touched && props.touched.property && props.touched.property.substructureType && props.errors && props.errors.property && props.errors.property.substructureType && (
								<Error text={props.errors.property.substructureType} />
							)}
							{!isSectionVisited && <Footer backClick={() => onPropertyFoundationTypeBack()} forwardClick={() => onPropertyFoundationTypeNext()} />}
						</React.Fragment>
					)}

					{(isSectionVisited || showRoofMaterial) && (props.values.property.policyType === "HO-3" || props.values.property.policyType === "HO-6") && (
						<React.Fragment>
							<Label text="What is the material of your roof?"></Label>
							<RowContainer>
								<ImageCheck
									label="Asphalt"
									src="/wp-content/uploads/2023/10/roof-material-01-asphalt.jpg"
									checked={props.values.property.roofType === "Asphalt"}
									onClick={() => {
										onRoofMaterialChange("Asphalt");
									}}
									style={{ marginRight: "1rem", width: "100%" }}
								/>
								<ImageCheck
									label="Fiberglass"
									src="/wp-content/uploads/2023/10/roof-material-02-fiberglass.jpg"
									checked={props.values.property.roofType === "Fiberglass"}
									onClick={() => {
										onRoofMaterialChange("Fiberglass");
									}}
									style={{ width: "100%" }}
								/>
							</RowContainer>
							<RowContainer>
								<ImageCheck
									label="Wood"
									src="/wp-content/uploads/2023/10/roof-material-03-wood.jpg"
									checked={props.values.property.roofType === "Wood"}
									onClick={() => {
										onRoofMaterialChange("Wood");
									}}
									style={{ marginRight: "1rem", width: "100%" }}
								/>
								<ImageCheck
									label="Slate"
									src="/wp-content/uploads/2023/10/roof-material-04-slate.jpg"
									checked={props.values.property.roofType === "Slate"}
									onClick={() => {
										onRoofMaterialChange("Slate");
									}}
									style={{ width: "100%" }}
								/>
							</RowContainer>
							<RowContainer>
								<ImageCheck
									label="Flat Roof"
									src="/wp-content/uploads/2023/10/roof-material-05-flat-roof.jpg"
									checked={props.values.property.roofType === "Single-Ply Membrane"}
									onClick={() => {
										onRoofMaterialChange("Single-Ply Membrane");
									}}
									style={{ marginRight: "1rem", width: "100%" }}
								/>
								<ImageCheck
									label="Metal"
									src="/wp-content/uploads/2023/10/roof-material-06-metal.jpg"
									checked={props.values.property.roofType === "Metal"}
									onClick={() => {
										onRoofMaterialChange("Metal");
									}}
									style={{ width: "100%" }}
								/>
							</RowContainer>
							<RowContainer>
								<ImageCheck
									label="Shake"
									src="/wp-content/uploads/2023/10/roof-material-07-shake.jpg"
									checked={props.values.property.roofType === "Shake-Treated"}
									onClick={() => {
										onRoofMaterialChange("Shake-Treated");
									}}
									style={{ marginRight: "1rem", width: "100%" }}
								/>
								<ImageCheck
									label="Clay"
									src="/wp-content/uploads/2023/10/roof-material-08-clay.jpg"
									checked={props.values.property.roofType === "Unknown"}
									onClick={() => {
										onRoofMaterialChange("Unknown");
									}}
									style={{ width: "100%" }}
								/>
							</RowContainer>
							<RowContainer>
								<ImageCheck
									label="Concrete"
									src="/wp-content/uploads/2023/10/roof-material-09-concrete.jpg"
									checked={props.values.property.roofType === "Concrete"}
									onClick={() => {
										onRoofMaterialChange("Concrete");
									}}
									style={{ marginRight: "1rem", width: "100%" }}
								/>
								<ImageCheck
									label="I'm not sure"
									src="/wp-content/uploads/2024/08/question-mark-bubble-speech-sign-symbol-icon-3d-rendering-scaled.jpg"
									checked={props.values.property.roofType === "Unsure"}
									onClick={() => {
										onRoofMaterialChange("Unsure");
									}}
									style={{ width: "100%" }}
								/>
							</RowContainer>
							{props.touched && props.touched.property && props.touched.property.roofType && props.errors && props.errors.property && props.errors.property.roofType && (
								<Error text={props.errors.property.roofType} />
							)}
							{!isSectionVisited && <Footer backClick={() => onPropertyRoofMaterialBack()} forwardClick={() => onPropertyRoofMaterialNext()} />}
						</React.Fragment>
					)}

					{(isSectionVisited || showOptionalFacilities) && (
						<React.Fragment>
							<InfoText
								text={`Property features like ${
									props.values.property.policyType === "HO-3" || props.values.property.policyType === "HO-6" ? "swimming pools, trampolines," : ""
								} flood zone proximity, and fire station proximity may impact insurance coverage and rates.`}
							/>
							<Label text="Select all that apply:"></Label>
							{(props.values.property.policyType === "HO-3" || props.values.property.policyType === "HO-6") && (
								<>
									<Checkbox
										label="My home has a trampoline"
										checked={props.values.property.hasTrampoline === "true"}
										onClick={() => {
											let value = "false";
											if (props.values.property.hasTrampoline == "false") {
												value = "true";
											}
											setFieldValue("property.hasTrampoline", value);
										}}
									/>
									<Checkbox
										label="My home has a swimming pool"
										checked={props.values.property.hasSwimmingPool === "true"}
										onClick={() => {
											let value = "false";
											if (props.values.property.hasSwimmingPool == "false") {
												value = "true";
											}
											setFieldValue("property.hasSwimmingPool", value);
										}}
									/>
								</>
							)}
							<Checkbox
								label="My home is within 10 miles of the coast"
								checked={props.values.property.distanceFromCoast === 15000}
								onClick={() => {
									let value = 99999;
									if (props.values.property.distanceFromCoast == 99999) {
										value = 15000;
									}
									setFieldValue("property.distanceFromCoast", value);
								}}
							/>
							<Checkbox
								label="A fire hydrant is within 1000ft of home"
								checked={props.values.property.distanceFromFireHydrant === 1000}
								onClick={() => {
									let value = 2000;
									if (props.values.property.distanceFromFireHydrant == 2000) {
										value = 1000;
									}
									setFieldValue("property.distanceFromFireHydrant", value);
								}}
							/>
							<Checkbox
								label="The nearest fire station is within 3 miles"
								checked={props.values.property.distanceFromFireDept === 3}
								onClick={() => {
									let value = 5;
									if (props.values.property.distanceFromFireDept == 5) {
										value = 3;
									}
									setFieldValue("property.distanceFromFireDept", value);
								}}
							/>
							<Checkbox
								label="My home is in a flood zone"
								checked={props.values.property.isHomeInFloodZone === "true"}
								onClick={() => {
									let value = "false";
									if (props.values.property.isHomeInFloodZone == "false") {
										value = "true";
									}
									setFieldValue("property.isHomeInFloodZone", value);
								}}
							/>
							{!isSectionVisited && <Footer backClick={() => onPropertyOptionalFacilityBack()} forwardClick={() => onPropertyOptionalFacilityNext()} />}
						</React.Fragment>
					)}

					{(isSectionVisited || showPropertyInsurance) && (
						<React.Fragment>
							<Label text="Is your home currently insured?"></Label>
							<div style={{ display: "flex", flexDirection: "row" }}>
								<Checkbox
									label="Yes"
									checked={props.values.property.isCurrentlyInsured === "true"}
									onClick={() => {
										sessionStorage.setItem("rrQuizPropertySectionVisited", "true");
										setFieldValue("property.isCurrentlyInsured", "true");
									}}
									style={{ marginRight: "1rem", width: "100%" }}
								/>
								<Checkbox
									label="No"
									checked={props.values.property.isCurrentlyInsured === "false"}
									onClick={() => {
										sessionStorage.setItem("rrQuizPropertySectionVisited", "true");
										setFieldValue("property.isCurrentlyInsured", "false");
										setTimeout(() => {
											setShowPropertyInsurance(false);
											setShowDiscounts(true);
										}, 200);
									}}
									style={{ width: "100%" }}
								/>
							</div>
							{props.touched &&
								props.touched.property &&
								props.touched.property.isCurrentlyInsured &&
								props.errors &&
								props.errors.property &&
								props.errors.property.isCurrentlyInsured && <Error text={props.errors.property.isCurrentlyInsured} />}

							{props.values.property.isCurrentlyInsured === "true" && (
								<React.Fragment>
									<Label text="How long have you been insured at this home (in years)?"></Label>
									<Dropdown
										placeholder="Select number of years"
										name="property.insuredForYears"
										value="property.insuredForYears"
										onChange={(value) => {
											setFieldValue("property.insuredForYears", value);
											props.validateField("property.insuredForYears");
										}}
										options={nofYearsList}
										error={`${
											props.touched &&
											props.touched.property &&
											props.touched.property.insuredForYears &&
											props.errors &&
											props.errors.property &&
											props.errors.property.insuredForYears
										}`}
										marginBottom="1rem"
									/>

									<Label text="Have you filed any claim in the last 5 years?"></Label>
									<div style={{ display: "flex", flexDirection: "row" }}>
										<Checkbox
											label="No claims"
											checked={props.values.property.claimFreeYears === 5}
											onClick={() => {
												setFieldValue("property.claimFreeYears", 5);
											}}
											style={{ marginRight: "1rem", width: "100%" }}
										/>
										<Checkbox
											label="Less than a year ago"
											checked={props.values.property.claimFreeYears === 0}
											onClick={() => {
												setFieldValue("property.claimFreeYears", 0);
											}}
											style={{ width: "100%" }}
										/>
									</div>
									<div style={{ display: "flex", flexDirection: "row" }}>
										<Checkbox
											label="1-2 years ago"
											checked={props.values.property.claimFreeYears === 1}
											onClick={() => {
												setFieldValue("property.claimFreeYears", 1);
											}}
											style={{ marginRight: "1rem", width: "100%" }}
										/>
										<Checkbox
											label="2-3 years ago"
											checked={props.values.property.claimFreeYears === 2}
											onClick={() => {
												setFieldValue("property.claimFreeYears", 2);
											}}
											style={{ width: "100%" }}
										/>
									</div>
									<div style={{ display: "flex", flexDirection: "row" }}>
										<Checkbox
											label="3-4 years ago"
											checked={props.values.property.claimFreeYears === 3}
											onClick={() => {
												setFieldValue("property.claimFreeYears", 3);
											}}
											style={{ marginRight: "1rem", width: "100%" }}
										/>
										<Checkbox
											label="4-5 years ago"
											checked={props.values.property.claimFreeYears === 4}
											onClick={() => {
												setFieldValue("property.claimFreeYears", 4);
											}}
											style={{ width: "100%" }}
										/>
									</div>
									{props.touched &&
										props.touched.property &&
										props.touched.property.claimFreeYears &&
										props.errors &&
										props.errors.property &&
										props.errors.property.claimFreeYears && <Error text={props.errors.property.claimFreeYears} />}
								</React.Fragment>
							)}

							{!isSectionVisited && <Footer backClick={() => onPropertyInsuranceBack()} forwardClick={() => onPropertyInsuranceNext()} />}
						</React.Fragment>
					)}

					{(isSectionVisited || showDiscounts) && (
						<React.Fragment>
							<InfoText
								text="Some insurers offer special discounts due to safety measures, reducing costs for homeowners. Depending on your selections below, you may qualify for one of these
								discounts."
							/>
							<Label text="Select all that apply:"></Label>
							<Checkbox
								label="Deadbolts"
								checked={props.values.property.hasDeadBolts === "true"}
								onClick={() => {
									onPropertyDiscountChange("hasDeadBolts");
								}}
							/>
							<Checkbox
								label="Smoke Alarms"
								checked={props.values.property.hasSmokeAlarm === "true"}
								onClick={() => {
									onPropertyDiscountChange("hasSmokeAlarm");
								}}
							/>
							<Checkbox
								label="Security Systems (professional)"
								checked={props.values.property.burglarAlarm === "true"}
								onClick={() => {
									onPropertyDiscountChange("burglarAlarm");
								}}
							/>
							<Checkbox
								label="Fire Extinguisher"
								checked={props.values.property.hasFireExtinguisher === "true"}
								onClick={() => {
									onPropertyDiscountChange("hasFireExtinguisher");
								}}
							/>
							<Checkbox
								label="Sprinkler System"
								checked={props.values.property.sprinklerLocation === "true"}
								onClick={() => {
									onPropertyDiscountChange("sprinklerLocation");
								}}
							/>
							<Checkbox
								label="Located in Secured Building"
								checked={props.values.property.isInSecuredBuilding === "true"}
								onClick={() => {
									onPropertyDiscountChange("isInSecuredBuilding");
								}}
							/>
							<Checkbox
								label="24/7 Guard on Duty"
								checked={props.values.property.has24x7Guard === "true"}
								onClick={() => {
									onPropertyDiscountChange("has24x7Guard");
								}}
							/>
							{type != "HOME" && (
								<>
									<RowContainer style={{ justifyContent: "center", marginTop: "2rem", alignItems: "baseline" }}>
										{!isSectionVisited && (
											<Link>
												<div style={{ marginRight: "1rem" }} className="light-link" onClick={() => onDiscountsBack()}>
													Previous
												</div>
											</Link>
										)}
										<Button onClick={getRates} text="Get My Rates" isLoading={props.isSubmitInProgress} />
									</RowContainer>
									{props.errorSubmitting && <Error text="A few required fields are missing" />}
									<ConsentLanguage>
										By clicking 'Get My Rates', you give us permission to share the info you've given us with{" "}
										<a href="/our-partners-auto-quiz" target="_blank" style={{ textDecoration: "underline", color: "blue" }}>
											our partners
										</a>{" "}
										to get you more accurate rate estimates. Rate Retriever will not store or resell your personal information.
									</ConsentLanguage>
								</>
							)}
							{type == "HOME" && (
								<RowContainer style={{ justifyContent: "center", marginTop: "2rem", alignItems: "baseline" }}>
									{!isSectionVisited && (
										<Link>
											<div style={{ marginRight: "1rem" }} className="light-link" onClick={() => onDiscountsBack()}>
												Previous
											</div>
										</Link>
									)}
									<Button onClick={propertyContinueClick} text="Next step" />
								</RowContainer>
							)}
						</React.Fragment>
					)}
				</React.Fragment>
			)}
		</PropertyWrapper>
	);
}

export default Property;
